module.exports = __webpack_public_path__ + "img/logooffice3.b452be44.png";